import React, { Component } from 'react';
import PropTypes from "prop-types";
import ReactDom from "react-dom";
import LoadingStates from "../../constants/states/LoadingStates";
import PrivateSERPResultsPagination from "./PrivateSERPResultsPagination";
import PrivateSpaceCardView from "./PrivateSpaceCardView";

export default class PrivateSpaceCardListView extends Component {

    static propTypes = {
        spaces: PropTypes.arrayOf(PropTypes.shape({
            spaceId: PropTypes.number.isRequired,
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            pricePerDay: PropTypes.number.isRequired,
            minimumDays: PropTypes.number.isRequired,
            distance: PropTypes.number.isRequired,
            created: PropTypes.number.isRequired,
            imageNames: PropTypes.arrayOf(PropTypes.string).isRequired,
        })),
        selectedSpace: PropTypes.number.isRequired,
        loadingState: PropTypes.symbol.isRequired,
        totalCount: PropTypes.number.isRequired,
        currentActivePage: PropTypes.number.isRequired,
    };

    handleScrollOnSpaceSelected = () => {
        if(this.props.selectedSpace !== 0) {
            const selectedDom = ReactDom.findDOMNode(this.refs[this.props.selectedSpace]);
            if(selectedDom != null) {
                selectedDom.scrollIntoView();
            }
        }
    };

    render() {
        if (this.props.loadingState === LoadingStates.FAILED_TO_LOAD) {
            return (
                <div className="card">
                    <div className="card-header">
                        No results found
                    </div>
                    <div className="embed-responsive embed-responsive-16by9">
                        <img alt="Card cap" className="card-img-top embed-responsive-item" src="img/butterPecan.jpg"/>
                    </div>
                    <div className="card-block">
                        <p className="card-text">Please change search filters and try again.</p>
                    </div>
                </div>);
        }
        if (this.props.spaces.length === 0) {
            return (
                <div className="card">
                    <div className="card-body">
                        <div className="card-header">
                            No results found
                        </div>
                        <div className="card-block">
                            <div className="alert alert-warning" role="alert">
                                <h2>No Spaces found in search area.</h2>
                                <h3>Please change search location or filters and try again.</h3>
                            </div>
                        </div>
                    </div>
                </div>);
        }
        this.handleScrollOnSpaceSelected();
        return (
            <ul className="list-unstyled card-list-scroll serp-space-details-card-list">
                {this.props.spaces.map(space => {
                    return (
                        <li
                            key={space.spaceId}
                            ref={space.spaceId}>
                            <PrivateSpaceCardView
                                spaceId={space.spaceId}
                                title={space.title}
                                description={space.description}
                                pricePerDay={space.pricePerDay}
                                minimumDays={space.minimumDays}
                                distance={space.distance}
                                created={space.created}
                                selected={this.props.selectedSpace === space.spaceId}
                                imageNames={space.imageNames}/>
                        </li>);
                })}
                <PrivateSERPResultsPagination
                    activePage={this.props.currentActivePage}
                    totalCount={this.props.totalCount} />
            </ul>);
    }
}

